<template>
  <div class="lego-timepicker">
    <div class="lego-timepicker-time">
      <lego-counter
        ref="hour"
        v-model="time_hour"
        center
        :min="0"
        :max="23"
        updown
        :disabled="disabled"
        @enter="(e) => onKeyEnter(e, 'h')"
        @keydown.tab.prevent="onKeyDown('h')"
        @blur="onBlur"
      />
      <lego-counter
        ref="minuteRefs"
        v-model="time_minute"
        center
        :min="0"
        :max="59"
        updown
        :disabled="disabled"
        @enter="(e) => onKeyEnter(e, 'm')"
        @keydown.tab.prevent="onKeyDown('m')"
        @blur="onBlur"
      />
    </div>
  </div>
</template>
<script setup>
import { computed, ref, toRefs, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '00:00'
  },
  disabled: { type: Boolean, default: false },
  type: {
    type: [Number, String],
    default: 0
  }
});
const emit = defineEmits(['update:modelValue', 'pressKey']);
const time_hour = ref(0);
const time_minute = ref(0);
const minuteRefs = ref(null);
const { modelValue, disabled, type } = toRefs(props);
const getValue = computed(
  () => getTimeText(time_hour.value) + ':' + getTimeText(time_minute.value)
);

watch(
  modelValue,
  (value) => {
    if (!value) return;
    const time = value.split(':');
    time_hour.value = +time[0];
    time_minute.value = +time[1];
  },
  { immediate: true }
);

watch(getValue, () => {
  emit('update:modelValue', getValue.value);
});

function getTimeText(txt) {
  let val = Number(txt);
  return val < 10 ? '0' + val : '' + val;
}

function onKeyDown(type) {
  if (type === 'h') {
    minuteRefs.value.$refs.input.focus();
    return;
  }
  emit('pressKey', this.type);
}

function onKeyEnter(e, type) {
  if (type === 'h') {
    minuteRefs.value.$refs.input.focus();
    return;
  }
  emit('pressKey', this.type);
  e.preventDefault;
}
function onBlur() {
  emit('update:modelValue', getValue.value);
}
</script>
<script>
export default {
  name: 'scpm-time-picker'
};
</script>

<style lang="scss" scoped>
:deep(.lego-counter__input) {
  border: 1px solid #a5a7ad;
  border-radius: 2px;
}
</style>
